import { Link, NavLink } from 'react-router-dom';
import SearchBar from './SearchBar.jsx';
import { useAuth } from '../lib/auth.js';
import { formatMemberNumber } from '../lib/member.js';

export default function Header() {
  const { user, profile, signOut } = useAuth();

  return (
    <header className="hb-header">
      <div className="hb-header__inner">
        <Link to="/" className="hb-logo" aria-label="Home Blockbuster — go to homepage">
          <span className="hb-logo__ticket">HOME</span>
          <span className="hb-logo__word">BLOCKBUSTER</span>
        </Link>
        <nav className="hb-nav">
          <NavLink to="/" end className={({ isActive }) => 'hb-nav__link' + (isActive ? ' is-active' : '')}>
            The Floor
          </NavLink>
          <NavLink to="/service/netflix" className={({ isActive }) => 'hb-nav__link' + (isActive ? ' is-active' : '')}>
            Browse by Service
          </NavLink>
          <NavLink to="/vault" className={({ isActive }) => 'hb-nav__link' + (isActive ? ' is-active' : '')}>
            The Vault
          </NavLink>
          <NavLink to="/members" className={({ isActive }) => 'hb-nav__link' + (isActive ? ' is-active' : '')}>
            Members
          </NavLink>
        </nav>
        <SearchBar />
        {user && (
          <div className="hb-header__me">
            {profile ? (
              <Link to={`/u/${profile.slug}`} className="hb-header__greet">
                <span className="hb-header__memberno">{formatMemberNumber(profile.member_number)}</span>
                {' '}
                {profile.display_name}
              </Link>
            ) : (
              <span className="hb-header__greet">Hi, {user.email}</span>
            )}
            <button
              type="button"
              className="hb-header__signout"
              onClick={signOut}
              aria-label="Sign out"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
      <div className="hb-header__tear" aria-hidden="true" />
    </header>
  );
}
